import SectionHeading from '@common/SectionHeading';
import React from 'react';

export interface HeadingProps {
  text?: string;
  className?: string;
  as?: React.ElementType;
  children?: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ className, ...props }) => {
  return (
    <div className={`${className}`}>
      <div className={`w-fit inline-block`}>
        <div className="flex flex-col z-auto ">
          <SectionHeading className="z-1" {...props} />
          <div className="bg-essense-bgHeading h-6 md:h-7  flex -mt-12 md:-mt-14 z-auto opacity-70"></div>
        </div>
      </div>
    </div>
  );
};

export default Heading;
